import { RefObject, useMemo } from "react";
import { HjorteviltJaktdataV1JaktdagSharedJaktdagResponse } from "~/src/api/generated/api";
import { firstNonEmpty } from "~/src/helpers/filters";
import useRegistrerJaktdag from "../common/useRegistrerJaktdag";
import { sumSettOgSkuttElg } from "./ElgHelpers";
import { JaktdagRegistrationDataElg, settElgFields, skuttElgFields } from "./ElgTypes";

export default function useRegistrerElg(
  initialData: HjorteviltJaktdataV1JaktdagSharedJaktdagResponse | undefined,
  scrollTopRef: RefObject<HTMLDivElement>,
) {
  const {
    jaktdagEksistererDialog,
    eksisterendeJaktdag,
    isSubmitting,
    successDialog,
    handleSubmit,
    handleChangeJaktomrade,
    formData: formData,
    formErrorsElg: formErrors,
    setFormData,
    setFormErrorsElg: setFormErrors,
    selectedJaktomrade,
    date,
    fellingsRapportLevert,
    loadingEksisterendeJaktdager,
    hasGodkjenteDyr,
  } = useRegistrerJaktdag(initialData, scrollTopRef, "Elg");

  const settOgSkuttData = useMemo(
    () => formData && sumSettOgSkuttElg(formData as JaktdagRegistrationDataElg),
    [formData],
  );
  const settErrorMessage = useMemo(
    () => firstNonEmpty(settElgFields.map((field) => formErrors[field])),
    [formErrors],
  );
  const skuttErrorMessage = useMemo(
    () => firstNonEmpty(skuttElgFields.map((field) => formErrors[field])),
    [formErrors],
  );

  return {
    handleChangeJaktomrade,
    handleSubmit,
    isSubmitting,
    formData: formData as JaktdagRegistrationDataElg,
    formErrors,
    setFormData,
    setFormErrors,
    fellingsRapportLevert,
    date,
    selectedJaktomrade,
    eksisterendeJaktdag,
    loadingEksisterendeJaktdager,
    jaktdagEksistererDialog,
    successDialog,
    settOgSkuttData,
    settErrorMessage,
    skuttErrorMessage,
    hasGodkjenteDyr,
  };
}
